// Bare `localhost` can't be used as a cookie domain, so fall back to a host-only cookie.
// Any other host (including `*.localhost` in docker) shares the cookie with its sibling apps.
export const getCookieDomain = (): string | undefined => {
	const hostname = window.location.hostname;
	return hostname === 'localhost' ? undefined : hostname.replace('account.', '');
};
